export class FutureDelivery {
  constructor( public readonly deliveryDate: Date ) {}
}
